import React from 'react';
import classNames from 'classnames';
import Button from '@profile/src/Components/Touchable';
import styles from './styles.module.scss';
import icCloseWhite from 'assets/svg/ic_close.svg';
import { switchToBSC } from '@profile/src/utils/ethereum';

const WarningWrongNetwork = ({
  className,
  onClose
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.txt
  }, "You need to connect to supported network"), /*#__PURE__*/React.createElement(Button, {
    onClick: switchToBSC,
    className: styles.btn
  }, /*#__PURE__*/React.createElement("span", null, "Switch network"))), /*#__PURE__*/React.createElement("img", {
    onClick: onClose,
    className: styles.close,
    src: icCloseWhite
  }));
};

export default WarningWrongNetwork;